import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-footer-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './footer-header.component.html',
  styleUrls: ['./footer-header.component.scss']
})
export class FooterHeaderComponent {
  constructor(private router: Router) { }

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  navigateToLogin(): void {
    window.open('/#/login/insurer', '_blank');
  }

  navigateToHome(): void {
    window.location.href = '/#/home';
  }
}
